import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, NgIf, MatButton, MatDialogClose]
})
export class ConfirmationDialogComponent implements OnInit {

 message: string = "Are you sure?"
  cancelButtonText = "Cancel"
  deleteButtonText = "Delete"
  showCancelButton: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
      if(data){
    this.message = data.message || this.message;
    if (data.buttonText) {
      this.deleteButtonText = data.buttonText.ok || this.deleteButtonText;
      this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      if(data.buttonText.cancel!=undefined){
        this.showCancelButton=true;
      }
    }
      }
  }
  ngOnInit() {
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
